import { useEffect, useRef, useState } from 'react';

export const useWorkbookV2EditorGridResize = () => {
  const editGrid = useRef(null);
  const [gridCols, setGridCols] = useState('grid-cols-2');

  useEffect(() => {
    if (!editGrid.current) return;
    const inputs = editGrid.current.querySelectorAll('textarea');
    if (inputs.length === 0) return;
    if (inputs.length === 1) {
      setGridCols('grid-cols-[1fr_1fr]');
      return;
    }

    const handleFocus = (index) => {
      if (index === 0) {
        setGridCols('grid-cols-[4fr_1fr]');
      } else if (index === 1) {
        setGridCols('grid-cols-[1fr_4fr]');
      }
    };

    const handleBlur = () => {
      setGridCols('grid-cols-[1fr_1fr]');
    };

    inputs.forEach((input, index) => {
      input.addEventListener('focus', () => handleFocus(index));
      input.addEventListener('blur', handleBlur);
    });

    return () => {
      inputs.forEach((input, index) => {
        input.removeEventListener('focus', () => handleFocus(index));
        input.removeEventListener('blur', handleBlur);
      });
    };
  }, []);

  return { editGrid, gridCols };
};
